import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../shared/constants';
import {
  BrandingLevelMasterGridResultModel,
  CompanyLevelStateModel,
  CompanyMappingGridResultModel,
  CompanyMasterGridResultModel
} from '../shared/models/company-data.model';
import { HeaderFilterData } from '../shared/models/product.model';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/companydatamapping';

  constructor(private httpClient: HttpClient) { }

  public getCompanyMappingGrid(param: LoadOptions): Observable<CompanyMappingGridResultModel> {
	return this.httpClient
	.post<CompanyMappingGridResultModel>(
		this.url + `/getCompanyMappingGrid/`, param,
		{ headers: this.headers }
	);
  }

  public getCompanyMasterGrid(param: LoadOptions): Observable<CompanyMasterGridResultModel> {
	return this.httpClient
	.post<CompanyMasterGridResultModel>(
		this.url + `/getCompanyMasterGrid/`, param,
		{ headers: this.headers }
	);
  }

  public getBrandingLevelMasterGrid(param: LoadOptions): Observable<BrandingLevelMasterGridResultModel> {
	return this.httpClient
	.post<BrandingLevelMasterGridResultModel>(
		this.url + `/getBrandingLevelMasterGrid/`, param,
		{ headers: this.headers }
	);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
			this.url + '/mappingAction', param,
			{ headers: this.headers }
		);
  }

  public getHeaderFiltersCompanyMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersCompanyMapping`, param,
				{ headers: this.headers }
			);
  }

  public getHeaderFiltersCompanyMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersCompanyMaster`, param,
				{ headers: this.headers }
			);
  }

  public deactivateCompanyMaster(param: CompanyLevelStateModel): Observable<any> {
	return this.httpClient
		.post(
		this.url + `/deactivateCompanyMaster`, param,
		{ headers: this.headers }
		);
  }
}
